<mat-card appearance="outlined">
	<mat-card-title [innerText]="'MAIN_APP_SERVICE_APP.serviceAppSynchronisation' | translate"></mat-card-title>
	<mat-card-content>
		<mat-progress-bar mode="determinate" value="{{ progressValue | async }}"></mat-progress-bar>
		<br/>
		<ejs-textbox [enabled]="false" [multiline]="true" [value]="content"></ejs-textbox>
		{{ "MAIN_APP_SERVICE_APP.anzahlDokumente" | translate }} ({{ downloadedDocuments | async }} / {{ totalDocuments | async }})
	</mat-card-content>
	
	<mat-dialog-actions>
		<button (click)="closeDialog()" [disabled]="!showOKButton" [innerText]="'MAIN_APP_SERVICE_APP.schliessen' | translate" class="confirm" mat-stroked-button></button>
		<button (click)="cancelSync()" [disabled]="!showCancelButton" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate" class="cancel" mat-stroked-button></button>
	</mat-dialog-actions>
</mat-card>